// extracted by mini-css-extract-plugin
export default {"showTableWrapper":"styles_showTableWrapper__DSpdk","btnToggleTable":"styles_btnToggleTable__LIuLd","btnIcon":"styles_btnIcon__Pnv-C","btnText":"styles_btnText__lPKy3"};